module.exports = __webpack_public_path__ + "img/a2.5cf306f5.png";